export interface ImageUploadProgress { completed: number; total: number; }
const progress = new Map<string, ImageUploadProgress>();
const listeners = new Set<() => void>();

export const getImageUploadProgress = (orderId?: string) => orderId ? progress.get(orderId) : undefined;
export const subscribeImageUploadProgress = (listener: () => void) => {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
};
export const reportImageUploadProgress = (orderId: string, completed: number, total: number) => {
    progress.set(orderId, {completed, total});
    if (progress.size > 20) progress.delete(progress.keys().next().value);
    listeners.forEach(listener => listener());
};
